import React from 'react';

import {
  Explainer,
  Flex,
  OneHalfLayout,
  PageWrapper,
  Panel,
  Placeholder
} from '@sopranodesign/pulse-components';
import { useQuery, useMutation, useQueryClient } from '@sopranodesign/pulse-hooks';
import { PolicyAccept, BackButton } from '@sopranodesign/pulse-channels';

import { acceptPolicy as acceptPolicyApi } from '../api/index';
import ViberDataForm from '../Components/ViberDataForm';

const ViberLink = () => {
  const query = useQuery({
    queryKey: [
      'viber/settings'
    ]
  });
  const queryClient = useQueryClient();

  const { mutate: acceptPolicy } = useMutation(acceptPolicyApi, {
    onSuccess: () => {
      queryClient.invalidateQueries('viber/settings');
    }
  });

  const PolicyCheck = () => {
    if (!query.data.data.has_given_data_consent) {
      return (
        <PolicyAccept
          handlePolicyAccept={acceptPolicy}
          policyUrl="https://sopranodesign.com/privacy/"
        />
      );
    }

    return (
      <Panel divider header="Link your Viber">
        <Flex col>
          <Explainer mb>
            Please fill out the fields below in line with Soprano Design
            Viber Provider API.{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="/docs">
              Learn more
            </a>
            .
          </Explainer>
          <ViberDataForm
            number={query.data.data.phone_number}
            token={query.data.data.api_id}
            prevBaseUri={query.data.data.base_uri}
            noSecret={query.data.data.has_not_api_key}
          />
        </Flex>
      </Panel>
    );
  };

  return (
    <PageWrapper
      center
      half
      header="Viber"
      prevAction={<BackButton to="/channels" />}>
      <Flex col center>
        <OneHalfLayout>
          {query.isLoading && <Placeholder items={1} subitems={2} />}
          {query.isSuccess && <PolicyCheck />}
        </OneHalfLayout>
      </Flex>
    </PageWrapper>
  );
};

export default ViberLink;
